@use "../../../sass/global/global" as *;

ux-iws-sf-page-title {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    gap: 20px;
    width: 100%;
    margin-bottom: 30px;

    h1,
    h2,
    h3 {
        @include font(light);
        font-size: 28px;
        line-height: 1.2;
        margin: 0;
    }

    svg {
        width: 50px;
        height: auto;
        display: inline-block;
    }

    @media (min-width: 768px) {
        gap: 30px;
        margin-bottom: 60px;

        h1,
        h2,
        h3 {
            font-size: 34px;
        }

        svg {
            width: 60px;
        }
    }
}
